import { View, type ViewProps } from 'react-native';

export type FormProps = ViewProps;

export function Form(props: FormProps) {
  return <View {...props} />;
}
